import styled, { css } from 'styled-components';

export const Container = styled.div`
  flex: 1;
  overflow-x: auto;
  margin: 1rem 0 1rem 0;
  display: flex;
  flex-direction: column;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TableBody = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

interface TableRowProps {
  $highlighted?: boolean;
  $isTopThree?: boolean;
}

export const TableRow = styled.div<TableRowProps>`
  ${({ theme: { colors }, $highlighted }) => css`
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colors.brandDarkTint95};
    font-size: 1rem;

    /* Add this to distribute height evenly among rows */
    flex: 1;

    ${
      $highlighted &&
      css`
        border-bottom: 2px solid ${colors.brandDark};
      `
    }

    &:hover {
      background: ${colors.brandDarkTint95};
    }
  `}
`;

interface TableCellProps {
  $align?: 'left' | 'right' | 'center';
  $colType?: string;
  $highlighted?: boolean;
  $isTopThree?: boolean;
}

export const TableCell = styled.div<TableCellProps>`
  ${({ theme: { colors }, $align, $colType, $isTopThree, $highlighted }) => css`
    flex: 1 1 auto;
    min-width: 0;
    font-size: ${$isTopThree ? '0.875rem' : '0.75rem'};
    color: ${colors.brandDark};
    text-align: ${$align ?? 'left'};
    padding: 0.2rem 0 0.2rem 0;

    ${
      $isTopThree &&
      css`
        padding: 0.25rem 0;
      `
    }

    ${
      $colType === 'number' &&
      css`
        flex: 0 0 auto;
        text-align: left;
        white-space: nowrap;
        width: 0;
        padding-right: 0.75rem;
      `
    }

    ${
      $colType === 'countryFlagIcon' &&
      css`
        flex: 0 0 auto;
        padding: 0 0.75rem;
        line-height: 1;
        width: ${$isTopThree ? '2.25rem' : '1.5rem'};
      `
    }

    ${
      $colType === 'percentage' &&
      css`
        flex: 0 0 auto;
        font-weight: 500;
        margin-left: auto;
        white-space: nowrap;
      `
    }

    ${
      $highlighted &&
      css`
        font-weight: 600;
      `
    }
  `}
`;

export const EmptyState = styled.p`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDarkAlpha50};
    text-align: center;
  `}
`;
